import { Routes } from "@lib/enums";

export type DashboardFocus = "floats" | "submissions";

const DEFAULT_FOCUS: DashboardFocus = "floats";

export interface DashboardFocusConfig {
  createdLabel: string;
  sentLabel: string;
  viewedLabel: string;
  listLinkText: string;
  chartTitle: string;
  route: string;
}

/**
 * Copy and routing for each dashboard analytics focus. Keeps the Floats and
 * Submissions dashboards identical apart from the wording and where the
 * metric cards link to.
 */
const CONFIG: Record<DashboardFocus, DashboardFocusConfig> = {
  floats: {
    createdLabel: "Floats created",
    sentLabel: "Floats sent",
    viewedLabel: "Floats viewed",
    listLinkText: "View floats",
    chartTitle: "Team Float emails",
    route: Routes.FLOATS,
  },
  submissions: {
    createdLabel: "Submissions created",
    sentLabel: "Submissions sent",
    viewedLabel: "Submissions viewed",
    listLinkText: "View submissions",
    chartTitle: "Team Submission emails",
    route: Routes.SUBMISSIONS,
  },
};

export default function getDashboardFocusConfig(
  focus?: string
): DashboardFocusConfig {
  return CONFIG[focus as DashboardFocus] ?? CONFIG[DEFAULT_FOCUS];
}
